import {useEffect, useState} from 'react';
import { useUser } from '../../../../providers/UserProvider.js';
import '../../dmView/style/App.css';
import { ThreeDots } from 'react-loader-spinner'
import { DEFAULT_PREFS } from '../constants.js';

const SignIn = ({socket}) => {
    const { username, setUsername, password, setPassword, setSessionID, setSpotifyInfo, setPrefs } = useUser();
    const [loginUsername, setLoginUsername] = useState('')
    const [password1, setPassword1] = useState('')
    const [password2, setPassword2] = useState('')
    const [openCreateAccount, setOpenCreateAccount] = useState(false)
    const [loggedIn, setLoggedIn] = useState(username !== 'Username' && password !== '')
    const [loading, setLoading] = useState(null)
    const [backendReady, setBackendReady] = useState(false)
    const [loginTried, setLoginTried] = useState(false)
    const [tokenLoginTried, setTokenLoginTried] = useState(false)
    const [cookieUsername, setCookieUsername] = useState('Username')
    const [error, setError] = useState('')
    const [serverStartingUp, setServerStartingUp] = useState(false)
    

    const goodLogin = (emitUsername, emitPassword, emitSessionID, emitSpotifyInfo, emitPrefs, emitLoginToken) => {
        setLoading(false)
        setServerStartingUp(false)
        setUsername(emitUsername);
        setPassword(emitPassword);
        setSessionID(emitSessionID);
        setSpotifyInfo(emitSpotifyInfo);
        console.log(emitPrefs)
        setPrefs(emitPrefs);
        setLoggedIn(true)
        setError('')
        setLoginTried(false)
        setBackendReady(false)

        setLoginCookie(emitUsername, emitLoginToken)
    }

    const setLoginCookie = (username, login_token) => {
        const payload = {
            username: username,
            login_token: login_token,
            ts: new Date().toISOString()
        }
        const value = encodeURIComponent(JSON.stringify(payload))
        // Expires in 30 days
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString()
        document.cookie = `dmBuddyUser=${value}; expires=${expires};`;
    }

    const clearLoginCookie = () => {
        document.cookie = 'dmBuddyUser=; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
    }


    const getLoginCookie = () => {
        try {
            const cookies = document.cookie.split('; ');
            const dmBuddyCookie = cookies.find(c => c.startsWith('dmBuddyUser='));
            if (!dmBuddyCookie) {
                return null; 
            }
            
            const value = decodeURIComponent(dmBuddyCookie.split('=')[1]);
            const payload = JSON.parse(value);
            
            // Check if cookie is expired (30 days)
            const cookieTime = new Date(payload.ts).getTime();
            const now = Date.now();
            const thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;
            
            if (now - cookieTime > thirtyDaysMs) {
                clearLoginCookie();
                return null;
            }

            return payload;
        } catch (e) {
            return null;
        }
    }

    // Auto-login on mount if login_token exists in cookie
    useEffect(() => {
        if (socket && !loggedIn) {
            submitTokenLogin();
        }
    }, [socket, loggedIn])

    useEffect(() => {
        if(socket) {
            socket.on('badLogin', (errorCode) => {
                setServerStartingUp(false)
                setLoading(false)
                if(errorCode === "userNotFound") {
                    setOpenCreateAccount(true)
                    setError("User not found: Create an account or continue as guest")
                } else if(errorCode === "passwordIncorrect") {
                    setError("Nat 1 history: Username or Password Incorrect")
                } else if(errorCode === "usernameTaken") {
                    setError("No... a 4 does not hit: Username already taken")
                }
            });
    
            //get this when login or successful account creation
            socket.on('goodLogin', async (userData) => {
                goodLogin(userData.emitUsername, userData.emitPassword, userData.emitSessionID, userData.emitSpotifyInfo, userData.emitPrefs, userData.emitLoginToken)
            });

            socket.on('backendready', () => {
                setBackendReady(true)
            });
        }
    }, [socket])

    useEffect(() => {
        if(backendReady) {
            setTimeout(() => {
                if(password1 && ((loginTried && !loggedIn) || loggedIn)) {
                    console.log("Re-loggin token w/ password");
                    reLogin()
                } else if(((tokenLoginTried && !loggedIn) || loggedIn)) {
                    console.log("Re-loggin token w/ token");
                    submitTokenLogin()
                }
            }, 100)
        }
    }, [backendReady])

    let validUsernameLength = loginUsername.length >= 8 
    let validPasswordLength = password1.length >= 8 

    let loginEnabled = validUsernameLength && validPasswordLength
    let passwordMatch = validPasswordLength && password1 === password2

    let createAccountEnabled = loginEnabled && passwordMatch

    let usernameStyle = openCreateAccount ? {outline: `2px solid ${validUsernameLength ? 'rgb(0, 255, 0)' : 'rgb(255, 0, 0)'}`} : {}
    let passwordStyle = openCreateAccount ? {outline: `2px solid ${validPasswordLength ? 'rgb(0, 255, 0)' : 'rgb(255, 0, 0)'}`} : {}

    const submitLogin = () => {
        setLoading(true)
        setServerStartingUp(false)
        if(loginEnabled) {
            socketLogin(loginUsername, password1, null)
        } else {
            setError("Nat 1 history: Username or Password Incorrect")
            setLoading(false)
        }
    }

    const socketLogin = (username, pw1, token) => {
        setTimeout(() => {
            setServerStartingUp(true)
        }, 3000)

        setTimeout(() => {
            socket.emit("login", username, pw1, token)
            setLoginTried(true)
        }, 500);
    }

    const reLogin = () => {
        if(username !== 'Username' && password !== '') {
            socket.emit("login", username, password, null)
        } else {
            submitLogin()
        }
    }

    const submitTokenLogin = () => {
        const cookieData = getLoginCookie();
        if (cookieData && cookieData.login_token) {
            setLoading(true);
            setServerStartingUp(false);
            setTokenLoginTried(true);
            setCookieUsername(cookieData.username);

            socketLogin(cookieData.username, null, cookieData.login_token)

        } else {
            setTokenLoginTried(false);
            console.log("No token found in cookie, skipping auto-login");
        }
    }

    const submitNewAccount = () => {
        setLoading(true)
        if(createAccountEnabled) {
            socket.emit("newAccount", loginUsername, password1)
        }
    }

    const signOut = () => {
        setLoggedIn(false)
        setPassword1('')
        setPassword2('')
        setUsername('Username')
        setPassword('')
        setLoginUsername('')
        setOpenCreateAccount(false)
        setLoginTried(false)
        setBackendReady(false)
        setSessionID(null);
        setSpotifyInfo(null);
        setPrefs(DEFAULT_PREFS);
        clearLoginCookie();
    }

    return (
        <>
            {loggedIn || username !== 'Username' ? (
                <div className='loginGreeting'>
                    <div><strong>Hey, {username}!</strong></div>
                    <button className='loginButtons' onClick={signOut}>Sign out</button>
                </div>
            ) : (
                <div className="loginContainer growImage">
                    <input
                        className='loginInput'
                        style={usernameStyle}
                        type="text"
                        placeholder='Username'
                        value={loginUsername}
                        onChange={(e) => setLoginUsername(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                submitLogin();
                            }
                        }}
                    />
                    <input
                        className='loginInput'
                        style={passwordStyle}
                        type="password"
                        placeholder='Password'
                        value={password1}
                        onChange={(e) => setPassword1(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                submitLogin();
                            }
                        }}
                    />
                    {openCreateAccount ? (
                        <div className=''>
                            <input
                                className={`loginInput`}
                                style={{outline: `2px solid ${passwordMatch ? 'rgb(0, 255, 0)' : 'rgb(255, 0, 0)'}`}}
                                type="password"
                                placeholder='Retype Password'
                                value={password2}
                                onChange={(e) => setPassword2(e.target.value)}
                            />
                            <div className='createAccountFlex' style={{justifyContent: loading ? 'center' : 'space-between'}}>
                                {loading ? (
                                    <ThreeDots
                                        visible={true}
                                        height="20"
                                        width="50"
                                        color="#FFFFFF"
                                        radius="1"
                                        ariaLabel="three-dots-loading"
                                    />
                                    
                                ) : (
                                    <>
                                        <button className='loginButtons' onClick={() => setOpenCreateAccount(false)}>Cancel</button>
                                        <button className='loginButtons' onClick={submitNewAccount} disabled={!createAccountEnabled}>Submit</button>        
                                    </>
                                )}
                            </div>
                            {(error || !validUsernameLength || !validPasswordLength || !passwordMatch) && 
                                <div className='info'>
                                    {error !== '' && <div className='loginError'> {error} </div>}
                                    {!validUsernameLength &&  <div className='loginError'>Username: atleast 8 characters</div>}
                                    {!validPasswordLength && <div className='loginError'>Password: atleast 8 characters</div>}
                                    {!passwordMatch && <div className='loginError'>Password: needs to match</div>}
                                </div>
                            }
                        </div>
                    ) : (
                        <>
                            <div className='createAccountFlex' style={{justifyContent: loading ? 'center' : 'space-between'}}>
                                {loading ? (
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                        <span style={{textWrap: "none"}}>Logging in - <b>{cookieUsername === "Username" ? loginUsername : cookieUsername}</b></span>
                                        <span style={{textWrap: "none", fontSize: "12px"}}><i>{serverStartingUp && 'server starting up... one sec'}</i></span>
                                        <ThreeDots
                                            visible={true}
                                            height="20"
                                            width="50"
                                            color="#FFFFFF"
                                            radius="1"
                                            ariaLabel="three-dots-loading"
                                        />
                                   </div>
                                ) : (
                                    <>
                                        <button className='loginButtons newAccountButton' onClick={setOpenCreateAccount}> New account? </button>
                                        <button className='loginButtons' onClick={submitLogin} disabled={!loginEnabled}> 
                                            Log in 
                                        </button>
                                    </>
                                )}
                            </div> 
                            {error !== '' &&
                                <div className='info'>
                                    {error && <div className='loginError'> {error} </div>}
                                </div>
                            }
                            
                        </>
                    )}
                </div>
            )}
        </>           
    );
};

export default SignIn;